import apiClient from "./client";

export const getCallRequestServices = async () => {
  const response = await apiClient.get("/call-request-services");
  return response.data;
};

export const createCallRequest = async (payload) => {
  const response = await apiClient.post("/call-requests", payload);
  return response.data;
};
